import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { of } from "rxjs";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";

@Component({
  selector: "kl-emq-get-password-form",
  templateUrl: "./emq-get-password-form.component.html",
  styleUrls: ["./emq-get-password-form.component.scss"],
})
export class EmqGetPasswordFormComponent implements OnInit, AfterViewInit {
  @ViewChild("focusElement", { static: true }) private focusElement: ElementRef;
  @Input() tabId: string;
  @Input() modalId: string;
  @Input() isReadOnly: boolean;
  @Input() mode: string;
  @Input() entity: {
    service_key: number;
    password: number;
  };
  title = "";
  alertShow: boolean;
  alertType: string;
  alertMessage: string;
  errorShow = false;
  buttons = [];

  constructor(
    private toastService: ToastService,
    private apiService: ApiService,
    private translateService: TranslateService,
    private utilService: UtilService,
    private explorerService: ExplorerService,
    private klLoadingService: KlLoadingService
  ) {}

  ngOnInit(): void {
    this.buttons = [
      {
        slug: "generate_password",
        show: this.utilService.isShow(
          (this.tabId ? this.tabId : this.modalId) + "001"
        ),
        icon: "",
        method: () => {
          if (this.entity.service_key) {
            this.klLoadingService.showLoading("");
            this.apiService
              .addData("one-time-password/create-password", {
                service_key: this.entity.service_key,
              })
              .subscribe(
                (response) => {
                  if (response) {
                    this.toastService.toastSuccess("generate_password_success");
                    this.klLoadingService.hide();
                    this.entity.password = response.password;
                  } else {
                    this.handleError("generate_password_error");
                  }
                },
                (error) => this.handleError(error)
              );
          } else {
            this.errorShow = true;
            this.handleError("required_fields_must_be_entered");
          }
        },
      },
    ];
  }

  ngAfterViewInit() {
    this.focusElement.nativeElement.focus();
  }

  formChange(event) {
    if (this.tabId) {
      this.explorerService.changeFormStatus({
        tabId: this.tabId,
        changeForm: event,
      });
    }
  }

  clearForm() {
    this.focusElement.nativeElement.focus();
    Object.keys(this.entity).forEach((o) => delete this.entity[o]);
  }

  handleResponse() {
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    if (this.tabId) {
      this.formChange(false);
      this.explorerService.closeTab(this.tabId);
    } else if (this.modalId) {
      this.explorerService.closeModal(this);
    }
  }

  handleError(error) {
    this.alertShow = true;
    this.errorShow = false;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
    return of(null);
  }
}
